import React, { Fragment } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import RetailAgentAgreementContent from "../../components/RetailAgentAgreement/RetailAgentAgreement";

const RetailAgentAgreement = () => {
  return (
    <Fragment>
      <div className="index_ico page_wrapper">
        <Header />
        <main className="page_content">
          <PageTitle
            pageTitle={"Becoming Retail Business advertising agent agreement"}
            pagesub={"Home"}
          />
          <RetailAgentAgreementContent />
        </main>
        <Footer />
        <Scrollbar />
      </div>
    </Fragment>
  );
};

export default RetailAgentAgreement;

